export function ordersReducer(state = {
    data: null,
    links: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'ORDER_RESET':
        return Object.assign({}, state, {
          data: null,
          links: null,
          isPending: true,
        })
        
      case 'GET_ORDERS_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false,
        })

    
        case 'GET_ORDERS_PENDING':
            return Object.assign({}, state, {
                // data: state.data,
                isPending: true,
            })
      default:
        return state
    }
  }

  export function ordersDetail(state = {
    data: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'GET_ORDERS_DETAIL_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results,
            isPending: false,
        })

        case 'GET_ORDERS_DETAIL_PENDING':
            return Object.assign({}, state, {
                data: null,
                isPending: true,
            })
      default:
        return state
    }
  }


export function ordersChat(state = {
  data: null,
  user: null,
  isPending: true,
}, action){
  switch(action.type){
    case 'GET_CHATTING_RESET': 
      return Object.assign({}, state, {
        isPending: true,
        data: null,
      })
    case 'GET_CHATTING_PENDING':
      return Object.assign({}, state, {
          isPending: true,
      })
    case 'GET_CHATTING_FULFILLED':
      return Object.assign({}, state, {
          data:  action.payload.data.results.data,
          user:  action.payload.data.results.user,
          isPending: false,
      })
    default:
      return state
  }
}


export function sendChat(state = {
  isSending: false,
}, action){
  switch(action.type){
    case 'SEND_CHATTING_FULFILLED':
      return Object.assign({}, state, {
        isSending: false,
      })
    case 'SEND_CHATTING_PENDING':
      return Object.assign({}, state, {
        isSending: true,
      })
    default:
      return state
  }
}

export function sendHasil(state = {
  isSuccess: false,
  isPending: false,
}, action){
  switch(action.type){
    case 'SEND_HASIL_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isPending: false,
      })
    case 'SEND_HASIL_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isPending: true,
      })
    default:
      return state
  }
}

export function taskAssigned(state = {
  isSuccess: false,
  isPending: false,
}, action){
  switch(action.type){
    case 'TASK_ASSIGNED_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isPending: false,
      })
    case 'TASK_ASSIGNED_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isPending: true,
      })
    default:
      return state
  }
}


export function sendEmail(state = {
  isSuccess: false,
  isPending: false,
}, action){
  switch(action.type){
    case 'SENDING_EMAIL_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isPending: false,
      })
    case 'SENDING_EMAIL_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isPending: true,
      })
    default:
      return state
  }
}